/* eslint-disable @typescript-eslint/naming-convention */
export enum AlertStateStoreModelEnum {
  Monitoring = 'MONITORING',
  Firing = 'FIRING',
  Resolved = 'RESOLVED',
  Dismissed = 'DISMISSED',
  NeverFired = 'NEVER_FIRED',
}

export enum AlertSeverityStoreModelEnum {
  Info = 'INFO',
  Warning = 'WARNING',
  Critical = 'CRITICAL',
}

export enum AlertType {
  DEVICE_FLAKY_CONNECTION_ALERT = 'DEVICE_FLAKY_CONNECTION_ALERT',
  FLAKY_MGC_CONNECTION = 'FLAKY_MGC_CONNECTION',
  CHARGER_COMMS_SLOW_ALERT = 'CHARGER_COMMS_SLOW_ALERT',
  DEVICE_COMMS_TIMEOUT_ALERT = 'DEVICE_COMMS_TIMEOUT_ALERT',
  CHARGER_OFFLINE_ALERT = 'CHARGER_OFFLINE_ALERT',
  ALL_CHARGERS_OFFLINE_ALERT = 'ALL_CHARGERS_OFFLINE_ALERT',
  CHARGER_CRITICAL_HARDWARE_FAULT = 'CHARGER_CRITICAL_HARDWARE_FAULT',
  CHARGER_CRITICAL_VEHICLE_FAULT = 'CHARGER_CRITICAL_VEHICLE_FAULT',
  CHARGER_CRITICAL_OPERATIONAL_FAULT = 'CHARGER_CRITICAL_OPERATIONAL_FAULT',
  CHARGER_CRITICAL_CONNECTIVITY_FAULT = 'CHARGER_CRITICAL_CONNECTIVITY_FAULT',
  CHARGER_NON_CRITICAL_HARDWARE_FAULT = 'CHARGER_NON_CRITICAL_HARDWARE_FAULT',
  CHARGER_NON_CRITICAL_VEHICLE_FAULT = 'CHARGER_NON_CRITICAL_VEHICLE_FAULT',
  CHARGER_NON_CRITICAL_OPERATIONAL_FAULT = 'CHARGER_NON_CRITICAL_OPERATIONAL_FAULT',
  CHARGER_NON_CRITICAL_CONNECTIVITY_FAULT = 'CHARGER_NON_CRITICAL_CONNECTIVITY_FAULT',
  CHARGER_UNCATEGORIZED_FAULT = 'CHARGER_UNCATEGORIZED_FAULT',
  DEVICE_OFFLINE_ALERT = 'DEVICE_OFFLINE_ALERT',
  CHARGER_FLAKY_CONNECTION_ALERT = 'CHARGER_FLAKY_CONNECTION_ALERT',
  CHARGER_COMMS_TIMEOUT_ALERT = 'CHARGER_COMMS_TIMEOUT_ALERT',
  POSSIBLE_BREAKER_TRIP_ALERT = 'POSSIBLE_BREAKER_TRIP_ALERT',
  MGC_TEMPORARILY_OFFLINE_ALERT = 'MGC_TEMPORARILY_OFFLINE_ALERT',
  EVSE_FAULTED_ALERT = 'EVSE_FAULTED_ALERT',
  EVSE_OCCUPIED_WITHOUT_TRANSACTION_ALERT = 'EVSE_OCCUPIED_WITHOUT_TRANSACTION_ALERT',
  GRID_LIMIT_BREACHED = 'GRID_LIMIT_BREACHED',
  DISPATCH_INITIATED = 'DISPATCH_INITIATED',
  OPTIMIZATION_UNABLE_TO_SATISFY_CHARGING_REQUIREMENTS = 'OPTIMIZATION_UNABLE_TO_SATISFY_CHARGING_REQUIREMENTS',
  OPTIMATOR_LOAD_PROFILE_STALE_ALERT = 'OPTIMATOR_LOAD_PROFILE_STALE_ALERT',
  POWER_DROPPED_TO_ZERO = 'POWER_DROPPED_TO_ZERO',
  POWER_DROPPED_TO_ZERO_AT_BATTERY_PACK_SOC_POINT = 'POWER_DROPPED_TO_ZERO_AT_BATTERY_PACK_SOC_POINT',
  POWER_DROPPED_TO_2KW = 'POWER_DROPPED_TO_2KW',
  MASS_AUTHORIZATION_ERRORS = 'MASS_AUTHORIZATION_ERRORS',
  REPEATED_EVSE_TRANSACTION_START_ISSUES = 'REPEATED_EVSE_TRANSACTION_START_ISSUES',
  REPEATED_VEHICLE_TRANSACTION_START_ISSUES = 'REPEATED_VEHICLE_TRANSACTION_START_ISSUES',
  VEHICLE_NO_TELEMATICS = 'VEHICLE_NO_TELEMATICS',
  MULTIPLE_VEHICLES_NO_TELEMATICS = 'MULTIPLE_VEHICLES_NO_TELEMATICS',
  POWER_LIMIT_CHANGE_REJECTED = 'POWER_LIMIT_CHANGE_REJECTED',
}

export enum ChargerRelatedAlertType {
  CHARGER_COMMS_SLOW_ALERT = 'CHARGER_COMMS_SLOW_ALERT',
  CHARGER_OFFLINE_ALERT = 'CHARGER_OFFLINE_ALERT',
  CHARGER_FLAKY_CONNECTION_ALERT = 'CHARGER_FLAKY_CONNECTION_ALERT',
  CHARGER_COMMS_TIMEOUT_ALERT = 'CHARGER_COMMS_TIMEOUT_ALERT',
}
